import React from 'react'
import { useHistory } from 'react-router'
import {
  Card,
  CardBody,
  Row,
  Col
} from 'reactstrap'
import { TitlePage } from 'components/atoms'
import { PaymentBankTransferCreateForm } from 'domains/payment-bank-transfer/organisms'
import CustomerOrdersApiV2 from 'api/v2/admins/customer-orders-api-v2'
import { ALERT_TYPES } from 'constants/alert-constants'
import PropTypes from 'prop-types'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const PaymentBankTransferCreatePage = ({ pageUtils }) => {

  const history = useHistory()

  const handleSubmitForm = async (values, formikBag) => {

    await CustomerOrdersApiV2.postBankTransfers(values)
      .then(() => {
        pageUtils.setAlertMsg('Successfully create payment bank transfer!', ALERT_TYPES.SUCCESS)
        history.push('list')
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
        formikBag.setErrors(error.response.data.messages)
      })
  }

  return (
    <Row>
      <Col lg={{ size: '8', offset: '2' }}>
        <TitlePage mainTitle='Create Payment Bank Transfer' subTitle='' />
        <Card>
          <CardBody>
            <PaymentBankTransferCreateForm handleSubmitForm={ handleSubmitForm } />
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

PaymentBankTransferCreatePage.propTypes    = propTypes
PaymentBankTransferCreatePage.defaultProps = defaultProps

export default PaymentBankTransferCreatePage
